import classnames from 'classnames'
import { useTranslation } from 'next-i18next'

import { ReadMore } from '../readMore'
import ReviewStars from '../reviews/reviewStars'

import styles from './productReviewHighLight.module.scss'
import stylesV2 from './productReviewHighlightV2.module.scss'

export interface ProductReviewHighLightProps {
  title: string
  avgRating: number
  children: string
  className?: string
  brandName?: string
  newPdpv2?: boolean
}

const ProductReviewHighLight = ({
  children,
  className,
  avgRating,
  title,
  brandName,
  newPdpv2,
}: ProductReviewHighLightProps) => {
  const { t } = useTranslation('common')
  const finalStyles = newPdpv2 ? stylesV2 : styles
  const classes = classnames(finalStyles.container, className)

  return (
    <div className={classes}>
      <ReviewStars totalStars={5} fillStars={avgRating} />
      <div className={finalStyles.container__title}>{title}</div>
      <ReadMore className={finalStyles.container__body}>{children}</ReadMore>
      {brandName && (
        <p className={finalStyles.brandName}>
          {t('customer_review_from')} {brandName}
        </p>
      )}
    </div>
  )
}
export default ProductReviewHighLight
